var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.5C0.5 0.367392 0.552678 0.240215 0.646447 0.146447C0.740215 0.0526784 0.867392 0 1 0H13C13.1326 0 13.2598 0.0526784 13.3536 0.146447C13.4473 0.240215 13.5 0.367392 13.5 0.5V2.5C13.5 2.62331 13.4544 2.74226 13.372 2.834L9 7.692V12.5C8.99992 12.6049 8.96685 12.7071 8.90547 12.7922C8.8441 12.8772 8.75752 12.9409 8.658 12.974L5.658 13.974C5.58287 13.999 5.50288 14.0058 5.4246 13.9939C5.34632 13.982 5.272 13.9516 5.20775 13.9053C5.1435 13.859 5.09116 13.7982 5.05504 13.7277C5.01893 13.6572 5.00006 13.5792 5 13.5V7.692L0.628 2.834C0.545608 2.74226 0.500022 2.62331 0.5 2.5V0.5ZM1.5 1V2.308L5.872 7.166C5.95439 7.25774 5.99998 7.37669 6 7.5V12.806L8 12.14V7.5C8.00002 7.37669 8.04561 7.25774 8.128 7.166L12.5 2.308V1H1.5Z",
    fill: "#6C757D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6e15f843.svg";
export { ForwardRef as ReactComponent };